import { css } from '@/styled-system/css';

export const popoverBodyStyles = css.raw({
  paddingBlock: 'default',
  paddingInline: 'default',
  overflowY: 'auto',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 'auto',
});
